/* src/app/acs-chat/components/typing-indicator/typing-indicator.scss */
.typing-indicator {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 16px 8px;
  font-size: 12px;
  color: #8e8e93;
}
.dots {
  display: flex;
  gap: 3px;
}
.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #8e8e93;
  animation: bounce 1.4s infinite ease-in-out both;
}
.dot:nth-child(1) {
  animation-delay: -0.32s;
}
.dot:nth-child(2) {
  animation-delay: -0.16s;
}
@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}
/*# sourceMappingURL=typing-indicator.css.map */
